<p-sidebar [visible]="true"
           [position]="'right'"
           [baseZIndex]="10000"
           [modal]="true"
           (onHide)="handleSideBarHide()"
           [style]="{width:'800px'}">
    <ng-template pTemplate="header">
        <div class="legal-docs-update-header">Update {{activeDocumentMenuItem === menuLevel3Enum.BusinessPermit ? 'Business Permit' : 'BIR 2303'}}</div>
    </ng-template>
    <div class="legal-docs-update-body">
        <div class="flex flex-row">
            <div style="width: 350px; margin-right: 60px;">
                <div class="legal-docs-update-input-item">
                    <div class="legal-docs-update-input-label">Issue Date</div>
                    <p-calendar [(ngModel)]="legalDocument.DocumentIssueDate" [maxDate]="today" placeholder="mm/dd/yyyy"></p-calendar>
                </div>
                <div class="legal-docs-update-input-item">
                    <div class="legal-docs-update-input-label">Expiration Date</div>
                    <p-calendar [(ngModel)]="legalDocument.DocumentExpirationDate" [minDate]="tomorrow" placeholder="mm/dd/yyyy"></p-calendar>
                </div>
                <div class="legal-docs-update-input-item">
                    <div class="legal-docs-update-input-label">Document Number</div>
                    <input [(ngModel)]="legalDocument.DocumentNumber" placeholder="Enter here" type="text" pInputText />
                </div>
            </div>

            <div *ngIf="!legalDocument.DocumentImageUrl" class="legal-docs-update-upload-img" (click)="handleUploadClick()">
                <div style="margin: auto;">
                    <i class="pi pi-plus-circle legal-docs-update-plus-button"></i>
                    <div class="legal-docs-update-label">Add</div>
                </div>
            </div>
            <div *ngIf="legalDocument.DocumentImageUrl">
                <p-image [src]="legalDocument.DocumentImageUrl" alt="Image" width="250" [preview]="true"></p-image>
                <div style="text-decoration: underline; font-size: 14px; color: #0A84FF; cursor: pointer; text-align:end;" (click)="handleUploadClick()">Upload new file</div>
            </div>
            <input id="idImgInput"
                   type="file"
                   accept="image/*"
                   style="display: none"
                   (change)="handleImageChange($event)" />
        </div>
    </div>

    <ng-template pTemplate="footer">
        <div style="padding: 20px; text-align: end">
            <p-button (click)="updateDocument()" [disabled]="loading" label="Update"></p-button>
        </div>
    </ng-template>

</p-sidebar>

<p-dialog [visible]="showUpdateOnReviewPopup" [closable]="false" [modal]="true" [draggable]="false" [style]="{width: '600px'}">
    <ng-template pTemplate="header">
        <div class="legal-docs-update-popup-header">Update in review</div>
    </ng-template>
    <div style="text-align: center; margin: auto">
        <div class="legal-docs-update-popup-body">Check your inbox in a few days for the outcome.</div>
        <button (click)="handleUpdateOnReviewPopupHide()" class="btn-darkblue" style="width: 273px; height: 45px; margin-top: 25px" pButton label="Got it"></button>
    </div>

</p-dialog>

<p-toast position="top-right"></p-toast>
